import BaseListStyle from "../../styles/BaseListStyle";
import {makeStyles} from "@material-ui/core/styles";

const UldTrackingStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    tariffHeaderList: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    tariffHeaderListEdit: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "fixed",
        width: "calc(100% - 10px)"
      },
    },
    checkbox: {
      minWidth: 70,
      margin: "0px 5px"
    },
    tariffLineList: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
      "& .MuiTableCell-head.MuiTableCell-paddingNone": {
        width: "38px",
      },
    },
    tariffLineListEdit: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
      "& .MuiTableCell-head.MuiTableCell-paddingNone": {
        width: "38px",
      },
      "& .MuiTableCell-body.MuiTableCell-paddingNone": {
        width: "42px",
      },
      "& .MuiTableRow-root[mode=update]": {
        width: "100%",
        display: "table"
      },
      "& .MuiTableRow-root[mode=add]": {
        width: "100%",
        display: "table"
      },
    },

    tariffBandList: {
      "& .MuiTable-root": {
        tableLayout: "fixed",
        width: "calc(100% - 20px)",
        display: "block"
      }
    },
    tariffBandListEdit: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "fixed",
        width: "calc(100% - 10px)"
      },
      "& .MuiTableRow-root[mode=update]": {
        width: "100%",
        display: "table"
      },
      "& .MuiTableRow-root[mode=add]": {
        width: "100%",
        display: "table"
      },
      "& .MuiTableRow-root.Mui-selected": {
        width: "100%",
        display: "table"
      },
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    menuPaper: {
      maxHeight: 500
    }
  }
}

export default UldTrackingStyles;
